module.exports = __webpack_public_path__ + "static/media/mobile_home_white_icon.6a2e8677.svg";